<template lang="html">
  <div id="floorplan-detail-units" class="tc">
    <button type="button" class="btn btn-link-action btn-units"
    @click="toggleUnits()">
      Units <i class="far fa-angle-down" :class="{ 'toggle-open': unitsOpened }"></i>
    </button>
    <div id="floorplan-detail-units-container">
      <transition name="slide-open">
        <div v-show="unitsOpened">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <div id="unit-list" class="pt-3 pb-1 rounded">
              <table class="mb-2">
                <tr>
                  <th>Floor</th>
                  <th>Exposure</th>
                </tr>
                <tr v-for="suite in suites"
                class="floorplan-detail-unit"
                :key="suite.number"
                :class="{
                  'unit-sold': suite.status !== 'available',
                  'unit-selected': suite.number === selectedUnitName
                }"
                @click="selectUnit(suite.number)">
                  <td class="py-1">{{ suite.floor }}</td>
                  <td class="py-1">{{ suite.exposure.join('') }}</td>
                  <td class="px-3">
                    <button v-if="suite.status === 'available'"
                    class="btn-view btn btn-link-action"
                    @click.stop="showView(suite.floor, suite.exposure.join(', '))">
                      <i class="fas fa-image"></i> see view
                    </button>
                    <div v-else>leased</div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { create } from 'vue-modal-dialogs';
import VueScrollTo from 'vue-scrollto';
import ViewsDialog from '@/components/Dialogs/ViewsDialog';

const dialog = create(ViewsDialog, 'floor', 'exposure', 'type', 'plan');

export default {
  name: 'floorplan-detail-units',
  props: {
    floorplan: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState({
      selectedUnitName: state => state.floorplans.selectedUnitName
    }),
    suites() {
      const allSuites = [];
      const suites = this.floorplan.suites.map(suite => ({
          number: suite.name,
          status: suite.status,
          floor: suite.floor,
          exposure: suite.exposure.split('')
        }));

      allSuites.push(...suites);
      return allSuites.sort((a, b) => {
        if (parseInt(a.floor, 10) < parseInt(b.floor, 10)) return -1;
        if (parseInt(a.floor, 10) > parseInt(b.floor, 10)) return 1;
        return 0;
      });
    }
  },
  data() {
    return {
      unitsOpened: false,
      keyplanScrolling: false,
      scrollFunction: null
    };
  },
  methods: {
    ...mapMutations({
      setSelectedUnitName: 'floorplans/setSelectedUnitName'
    }),
    toggleUnits() {
      this.unitsOpened = !this.unitsOpened;
    },
    showView(floor, exposure) {
      console.log(floor, exposure, this.floorplan.viewType, this.floorplan);
      dialog(floor, exposure, this.floorplan.viewType, this.floorplan);
    },
    selectUnit(number) {
      this.setSelectedUnitName(number);
      this.keyplanScrolling = true;
    },
    scrollToSelectedUnit() {
      if (this.scrollFunction) this.scrollFunction();
      this.scrollFunction = VueScrollTo.scrollTo('.unit-selected', 500, {
        container: '#floorplan-detail .scrollable-content-content',
        offset: -300
      });
    }
  },
  watch: {
    selectedUnitName() {
      if (this.selectedUnitName && !this.keyplanScrolling) {
        if (this.unitsOpened) {
          this.$nextTick(() => {
            this.scrollToSelectedUnit();
          });
        } else {
          this.unitsOpened = true;
          setTimeout(() => {
            this.scrollToSelectedUnit();
          }, 600, this);
        }
      } else {
        this.keyplanScrolling = false;
      }
    }
  },
  mounted() {
    if (this.selectedUnitName) {
      this.unitsOpened = true;
      setTimeout(() => {
        this.scrollToSelectedUnit();
      }, 600, this);
    }
  }
};
</script>

<style lang="scss" scoped>
#floorplan-detail-units-container {
  overflow-y: hidden;
}

.fa-angle-down {
  transition: transform 0.3s;
  &.toggle-open {
    transform: rotate(-180deg);
  }
}

#unit-list {
  background-color: var(--background-secondary);

  .fa-circle {
    color: var(--unit-sold);
  }

  table {
    th {
      padding: 0 22px;
      font-size: 0.8rem;
      font-family: Scandia-Regular, sans-serif;
      font-weight: 400;
    }

    td {
      font-family: Scandia-Regular, sans-serif;
      text-transform: uppercase;
    }
  }
}

.floorplan-detail-unit {
  cursor: pointer;
}

.unit-sold {
  cursor: not-allowed;
  background: var(--unit-sold);
  color: hsl(var(--unit-sold-h), var(--unit-sold-s), calc(var(--unit-sold-l) - 10%));

  button {
    color: hsl(var(--unit-sold-h), var(--unit-sold-s), calc(var(--unit-sold-l) - 10%));
    cursor: not-allowed;
  }
}

.unit-selected {
  background: var(--availability-unit);
  color: white;

  button {
    color: white;
  }
}

.btn-units {
  color: black;
  border-radius: 4px;
  border: 2px solid var(--text);

  padding: 5px 25px 3px;

  &:hover {
    border: 2px solid var(--text-dark);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanDetail/FloorplanDetailUnits.vue